import { Down as DownArrow, Up as UpArrow } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';

interface PercentageIconProps {
  value: number;
  toFixed?: number;
  style?: any;
}

const PercentageChange = (props: PercentageIconProps) => {
  const { value } = props;

  const color = value <= 0 ? 'var(--color-content-status-success-secondary)' : 'var(--color-content-status-danger-secondary)';
  const icon =
    value > 0 ? (
      <UpArrow style={{ width: '15px', height: '15px', color }} />
    ) : (
      <DownArrow style={{ width: '15px', height: '15px', color }} />
    );

  return (
    <Box sx={{ ...flex.itemsCenter, ...props.style }}>
      {icon}
      <Box sx={{ color }}> {formattedValue(value, props.toFixed)}</Box>
    </Box>
  );
};

export const formattedValue = (value, toFixed?: number) =>
  value.toFixed(toFixed ?? 2) === 'Infinity' ? 'NA' : `${value.toFixed(toFixed ?? 2)}%`;

export default PercentageChange;
